import React, { useState } from 'react';
import { FaShare, FaTimes, FaQrcode, FaLink } from 'react-icons/fa';
import { QRCodeSVG } from 'qrcode.react';
import './style/ShareButton.css';

const ShareButton = ({ eventId, eventName, shareUrl }) => {
  const [showModal, setShowModal] = useState(false);
  const [showQR, setShowQR] = useState(false);
  const [copied, setCopied] = useState(false);

  const url = shareUrl || `${window.location.origin}/${eventId}/upload`;

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: eventName || 'Invitation',
          text: 'Rejoignez cet événement !',
          url,
        });
        setShowModal(false);
      } catch (err) {
        if (err?.name !== 'AbortError') console.error('Erreur de partage:', err);
      }
    } else {
      try {
        await navigator.clipboard.writeText(url);
        setCopied(true);
        setTimeout(() => {
          setCopied(false);
          setShowModal(false);
        }, 1200);
      } catch (e) {
        console.error('Erreur de copie:', e);
      }
    }
  };

  const handleShowQR = () => setShowQR(true);
  const handleCloseQR = () => setShowQR(false);
  const handleCloseModal = () => {
    setShowModal(false);
    setShowQR(false);
  };

  return (
    <>
      {/* Bouton principal centré */}
      <div className="sharebutton-container">
        <button
          className="sharebutton-main"
          onClick={() => setShowModal(true)}
          aria-label="Partager l'invitation"
          title="Partager l'invitation"
        >
          <FaShare />
        </button>
      </div>

      {/* Modal principal */}
      {showModal && !showQR && (
        <div className="review-modal-share" onClick={handleCloseModal}>
          <div className="share-modal-card" onClick={(e) => e.stopPropagation()}>
            <button className="share-modal-close" onClick={handleCloseModal}>
              <FaTimes />
            </button>

            <h3 className="share-modal-title">
              Si la personne est à côté de vous, montrez-lui le QR code
              <br />
              <span>Sinon partagez le lien d'invitation</span>
            </h3>

            <div className="share-modal-actions">
              <button className="share-btn-gold" onClick={handleShowQR}>
                <FaQrcode size={22} /> MONTRER LE QR CODE
              </button>

              <button className="share-btn-gold" onClick={handleShare}>
                <FaLink size={22} />
                {copied
                  ? '✓ COPIÉ !'
                  : navigator.share
                  ? "PARTAGER LE LIEN D'INVITATION"
                  : "COPIER LE LIEN D'INVITATION"}
              </button>
            </div>
          </div>
        </div>
      )}
        
      {/* Modal QR Code */}
      {showQR && (
        <div className="review-modal-share" onClick={handleCloseQR}>
          <div className="share-modal-card" onClick={(e) => e.stopPropagation()}>
            <button className="share-modal-close" onClick={handleCloseQR}>
              <FaTimes />
            </button>

            <h3 className="share-modal-title">
              Faites scanner ce QR pour inviter les personnes autour de vous !
            </h3>

            <div className="share-modal-qr">
              <QRCodeSVG value={url} size={250} />
            </div>

            {eventName && <p className="share-modal-eventname">{eventName}</p>}
          </div>
        </div>
      )}
    </>
  );
};

export default ShareButton;
